import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { connect } from 'react-redux'
import Card, { CardList } from '~/common/card'
import Search from './search'
import Add from './add'
import Edit from './edit'
import { deattachContact, fetchContacts } from '../actions'

class ContactCardList extends Component {
  componentDidMount() {
    let { project, dispatch } = this.props

    dispatch(
      fetchContacts({
        project_id: project.get('id'),
      })
    )
  }

  render() {
    let { contacts = List(), project, contactsLoading, contactsError, creating, adding, editing, dispatch } = this.props

    contacts = contacts.filter(c => c.get('projects', List()).find(p => p.get('id') === project.get('id')))

    let editingContact = editing ? contacts.find(c => c.get('id') === editing) : false

    return (
      <Card title={`Yhteyshenkilöt (${contacts.size})`} icon="users" loading={contactsLoading} classTag="contactpeople">
        <CardList
          items={contacts.map(c => ({ value: `${c.get('name')} (${c.get('email')})`, contact: c.toJS() })).toArray()}
          onRemove={item => dispatch(deattachContact(item.contact.id, 'project_id', project.get('id')))}
          onEdit={item => dispatch({ type: 'CARD_CONTACT_EDIT', id: item.contact.id })}
        />
        <div className="contact-card-add">
          <Search organization_id={project.get('organization_id')} project_id={project.get('id')} />
          <div className="contact-card-add-create">
            <button
              onClick={e => e.preventDefault() & dispatch({ type: 'CARD_CONTACT_CREATE', add: true })}
              className="button-plain">
              Lisää
            </button>
          </div>
        </div>
        {editingContact ? (
          <Edit
            project={project}
            contact={editingContact}
            organization_id={project.get('organization_id')}
            onClose={() => dispatch({ type: 'CARD_CONTACT_EDIT', id: false })}
          />
        ) : creating ? (
          <Add
            project={project}
            organization_id={project.get('organization_id')}
            onClose={() => dispatch({ type: 'CONTACT_CREATE_CLOSE' })}
          />
        ) : null}
      </Card>
    )
  }
}

export default connect(state => ({
  contacts: state.contacts || List(),
  contactsLoading: state.contactsLoading,
  contactsError: state.contactsError,
  creating: state.cardContactCreating,
  editing: state.cardContactEditing,
}))(ContactCardList)
